import { appendParamsToRoute } from 'utils/common.util';

// API //////////////////////////////////////////////////////////////////
export const SupervisorMessagesUrl = (symbol12Chars: string): string =>
  `/api/v1/dashboard/supervisor_message/?search=${symbol12Chars}`;

export const CodalReportsUrl = (symbol12Chars: string): string =>
  `/api/v1/data_export/codal_report/?symbol_12chars=${symbol12Chars}`;

export const MarketDataHistoryUrl = (symbol12Chars: string): string =>
  `/api/v1/securities/${symbol12Chars}/market_data/history/`;

export const PreferencesUrl = (watchlistType?: number): string =>
  `/api/v1/account/watchlist_preferences/${
    watchlistType ? `?watchlist_type=${watchlistType}` : ''
  }`;

export const AllIndustriesUrl = (): string => `/api/v1/securities/industries/`;

export const SecuritySocketUrl = (
  symbol12Chars: string,
  isOption = false,
): string => `/ws/v1/${isOption ? 'options' : 'security'}/${symbol12Chars}/`;

export const securityInfoUrl = (id: string): string =>
  `/api/v1/securities/${id}/`;

// Routes //////////////////////////////////////////////////////////////////
export const SecurityOverviewPageRoute = (
  security: string,
  isOption?: boolean,
): string => appendParamsToRoute('/security/overview/', { security, isOption });
export const SupervisorMessagePageRoute = (
  security: string,
  isOption?: boolean,
): string =>
  appendParamsToRoute('/security/supervisor-message/', { security, isOption });
export const CodalReportPageRoute = (
  security: string,
  isOption?: boolean,
): string =>
  appendParamsToRoute('/security/codal-report/', { security, isOption });
export const MarketDepthRoute = (id: string): string =>
  `/security/market-depth/?security=${id}`;
